import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface DictionaryState {
  words: any[]
  dictionaries: any[]
  error: any
  success: any
}

export const useDictionaryStore = defineStore('dictionary', {
  state: (): DictionaryState => ({
    words: [],
    dictionaries: [],
    error: null,
    success: {},
  }),

  getters: {
    getDictionaries: (state) => state.dictionaries,
    getWords: (state) => state.words,
    getWordTransactionSuccess: (state) => state.success,
    getWordTransactionError: (state) => state.error,
  },

  actions: {
    async fetchDictionaries() {
      try {
        const response = await api().get('/namesearch/dictionary')
        this.dictionaries = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchWords() {
      try {
        const response = await api().get('/namesearch/dictionary/word')
        this.words = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchFilteredWords(id: string | number) {
      try {
        const response = await api().get('/namesearch/dictionary/word?dictionaryId=' + id)
        this.words = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async addWord(data: any) {
      try {
        const response = await api().post('/namesearch/dictionary/word', data)
        this.success = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async editWord(data: any) {
      try {
        const response = await api().put('/namesearch/dictionary/word?wordId=' + data.id, data.form)
        this.success = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async deleteWord(data: any) {
      try {
        const response = await api().delete('/namesearch/dictionary/word?wordId=' + data.id, data)
        this.success = response.data
      } catch (error: any) {
        this.error = error.message
      }
    },
  },
})
